import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  getCheckoutResultsApi,
  verifyAuthenticateTokenApi,
  getDeliveryTrackingLinkApi
} from 'api/fesc/client'
import * as C from './constants'
import { previewModeGetCheckoutResultApi } from 'api/fesc/previewModeClient'
import { isEmpty } from '@jarvis.oddle/core/tools/string'

export const verifyCallingGetCheckoutResult = (action) => (...params) => async (dispatch, getState) => {
  try {
    const { storeOrderId } = params[0]
    const previewMode = getState()['@customisation'].data.previewMode
    if (!previewMode && isEmpty(storeOrderId)) {
      return { success: false, error: 'Missed storeOrderId' }
    }
    return dispatch(action(...params))
  } catch (_) {
    // fail gracefully
  }
}

export const getCheckoutResultsAction = verifyCallingGetCheckoutResult(asyncAction({
  getApi: (getState) => {
    const previewMode = getState()['@customisation'].data.previewMode
    return previewMode ? previewModeGetCheckoutResultApi : getCheckoutResultsApi
  },
  requestAction: C.GET_CHECKOUT_RESULTS_REQUEST,
  successAction: C.GET_CHECKOUT_RESULTS_SUCCESS,
  failureAction: C.GET_CHECKOUT_RESULTS_FAILURE
}))

export const verifyAuthenticateTokenAction = asyncAction({
  api: verifyAuthenticateTokenApi,
  requestAction: C.GET_VALIDATE_TOKEN_REQUEST,
  successAction: C.GET_VALIDATE_TOKEN_SUCCESS,
  failureAction: C.GET_VALIDATE_TOKEN_FAILURE
})

export const getDeliveryTrackingLinkAction = asyncAction({
  api: getDeliveryTrackingLinkApi,
  requestAction: C.GET_DELIVERY_TRACKING_LINK_REQUEST,
  successAction: C.GET_DELIVERY_TRACKING_LINK_SUCCESS,
  failureAction: C.GET_DELIVERY_TRACKING_LINK_FAILURE
})
